<style lang="scss" scoped>
    .font-20{
        font-size: 20px;
    }
    .datasform{
        .ivu-form-item{
            margin-bottom: 10px;
        }
    }
    .pointer{
        cursor: pointer;
    }
    .product-title{
        line-height: 36px;
        border-bottom: 1px solid #dedede;
        margin-bottom: 16px;
        padding-left: 20px;
        background-color: #d01ec2;
        color: #fff;
    }
    .product-name{
        white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
    }
</style>
<template>
    <div class="bg-fff shadow margin-top-20 productForm">
        <header class="product-title font-bold">产品信息</header>

        <div class="padding-20">
            <div v-for="(product,proindex) in comProduct" :key="proindex" style="border:1px solid #eee">
                <div class="clearfix" style="background:#f5f5f5;line-height:36px;height:36px">
                    <Col span="24">
                        <Col span="4">
                            <div style="display:flex;align-items: center;">
                                <span class="padding-left-10 margin-right-10 b2ccolor-dark-primary font-weight">
                                    {{product.sellerSku}}
                                </span>
                                <Icon v-if="alltype != 'query'" class="font-20 pointer" type="ios-add-circle" @click="addItem(proindex)"></Icon>
                            </div>
                        </Col>
                        <Col span="4">
                            <div>ID:<span class="font-weight">{{product.productsItemId}}</span></div>
                        </Col>
                        <Col span="4">
                            <div>ASIN:<span class="font-weight">{{product.asin}}</span></div>
                        </Col>
                        <Col span="4">
                            <div>数量:<span class="font-weight">{{product.quantity}}</span></div>
                        </Col>
                        <Col span="4">
                            <div>金额:<span class="font-weight">{{product.itemAmount}} {{product.currencyCode}}</span></div>
                        </Col>
                        <Col span="4">
                            <div style="text-align:right" class="margin-right-20">
                                <span v-if="product.isShip == 'automatic'" class="light-primary span-padding line-24">发货产品</span>
                                <span v-else class="b2cspan-error span-padding line-24">不发货产品</span>
                            </div>
                        </Col>
                    </Col>
                </div>

                <table class="width-100per">
                    <tr>
                        <td class="width-30per" style="border-right:1px solid #ddd">
                            <div class="padding-left-10" v-if="fulfillmentChannel=='AFN'"> {{comProduct[0].erpSku || '--'}} </div>
                            <div class="margin-left-10 padding-top-10 datasform clearfix" v-for="(item,itemindex) in product.orderItemList" :key="itemindex">
                                <div style="height:35px;display:flex;align-items: center;">
                                    <div class="pull-left">
                                        <Icon v-if="alltype != 'query'" class="font-14 pointer" type="md-close" @click="delectItem(proindex,itemindex)"></Icon>
                                    </div>
                                    <div style="width:150px;" class="pull-left" :class="{'margin-left-20' : alltype=='edit'}">
                                        <span v-if="alltype == 'query'" class="b2ccolor-dark-primary font-weight">{{item.erpSku}}</span>
                                        <Select v-else clearable filterable v-model="item.erpSku" ref="zierpselect" remote :remote-method="remoteMethod1" :loading="loading1" @on-change="aaaaa(itemindex,product.orderItemList)">
                                            <Option v-for="json in erpSkusList" :value="json.name" :key="json.id">{{ json.name }}</Option>
                                        </Select>
                                    </div>
                                    <div style="width:60px;" class="pull-left margin-left-20">
                                        <span v-if="alltype == 'query'">✖
                                            <!-- <div class="circle"> -->
                                                <span class="b2ccolor-error font-weight numberSpan">{{item.quantity}}</span>
                                            <!-- </div> -->
                                        </span>
                                        <InputNumber v-else :min="1" v-model="item.quantity"></InputNumber>
                                    </div>
                                    <div style="width:120px;" class="pull-left margin-left-40">
                                        <span v-if="alltype == 'query'" v-show="item.insuranceAmount>0">
                                                <span class="font-weight">投保单价 {{item.insuranceAmount}} {{product.currencyCode}}</span>
                                        </span>
                                        <Input v-else v-model="item.insuranceAmount" placeholder="投保单价" style="width: 80px"></Input>
                                        <Tooltip v-if="alltype != 'query'" content="投保单价" placement="top"><Icon style="vertical-align: middle;" class="font-20" type="information-circled"></Icon></Tooltip>
                                    </div>
                                </div>
                                <div >
                                    <span v-if="alltype == 'query'">{{item.title}}</span>
                                    <span v-else-if="alltype == 'edit' && item.title">{{item.title}}</span>
                                    <div v-else-if="alltype == 'edit' && !item.title">
                                        <span>{{item.erpSku | filterErpsku('name',erpSkusList,itemindex,product.orderItemList)}}</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td style="border-right:1px solid #ddd;" class="padding-left-10 width-15per">
                            <div :title="product.lineId|transferText('name',productLineAll)" class="product-name">
                                项目: <span v-if="product.lineId!=0" class="b2ccolor-warning font-weight span-padding line-24">
                                    {{product.lineId|transferText('name',productLineAll)}}
                                </span>
                                <span v-else> -- </span>
                            </div>
                        </td>
                        <td style="border-right:1px solid #ddd;" class="padding-left-10 width-15per">
                            <div>
                                运费: <span class="font-weight">{{product.shippingPrice}} {{product.currencyCode}}</span>
                            </div>
                            <div>
                                税费: <span class="font-weight">{{product.taxPrice}} {{product.currencyCode}}</span>
                            </div>
                        </td>
                        <td style="border-right:1px solid #ddd" class="padding-left-10 width-15per">
                            <div >
                                FOB: <span class="font-weight">{{product.itemCost}} {{product.costCurrency?product.costCurrency:product.currencyCode}}</span>
                            </div>
                            <div >
                                DDP: <span class="font-weight">{{product.ddpCost}} {{product.costCurrency?product.costCurrency:product.currencyCode}}</span>
                            </div>
                        </td>
                        <td class="padding-left-10 width-25per">
                            <div class="product-name">
                                Tracking:
                                <span class="b2ccolor-success font-weight" v-if="product.trackNo">
                                    [{{product.shippingMethodCode}}]{{product.trackNo}}
                                </span>
                                <span v-else> -- </span>
                            </div>
                            <div>
                                折扣号:
                                <span class="font-weight" v-if="product.promotionIds">
                                    {{product.promotionIds}}
                                </span>
                                <span v-else> -- </span>
                            </div>
                            <div>
                                折扣金额:
                                <span class="font-weight">
                                    {{product.promotionDiscountPrice}} {{product.promotionDiscountCurrencyCode}}
                                </span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState,mapGetters } from 'vuex'
import { HttpProductErpSku } from '@/service/boss/dictionary'
import { HttpVsSkuList } from '@/service/boss/allot';
export default {
    props:['comProduct','alltype','fulfillmentChannel','orderOrgId'],
    data(){
        return {
            erpSkusList:[],
            loading1:false,
            erpskutitle:"",
            filtertitle:'',

        }
    },
    computed: {
        ...mapState('boss',['productLineAll']),
        //...mapGetters('boss',['warehouses']),
    },
    methods:{

        aaaaa(index,list){
            list[index].title = '';
            list[index].quantity = 0;
            list[index].productId ='';
            list[index].insuranceAmount =0;
        },
        remoteMethod1(query){
            this.loading1 = true;
            HttpVsSkuList({page: 1,rows: 100,contextId:this.orderOrgId,'search[CN_erpSku]':query}).then(res => {
                // console.log(res)
                this.loading1 = false;
                this.erpSkusList = res.data.content.map((item) => {
                    return { name: item.erpSku, id: item.id, title:item.nameEn }
                });
            });
        },
        addItem(index){
            let data = {
                erpSku:'',
                quantity:0,
                title:"",
                productId:"",
                insuranceAmount:0
            }
            if(this.comProduct[index].orderItemList){
                this.comProduct[index].orderItemList.push(data)
            }else{
                this.comProduct[index].orderItemList = []
                this.comProduct[index].orderItemList.push(data)
            }
            // console.log(this.comProduct[index].orderItemList)
        },
        delectItem(proindex,itemindex){
            this.comProduct[proindex].orderItemList.splice(itemindex,1)
        },
    },
    filters:{
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach(item => {
                if (item[key] === val) {
                    text = item[textKey]
                }
            });
            return text;
        },
        filterErpsku(val, textKey,list = [],index,list2= [] ){
            let text = "", pid='' ;
            list.forEach(item => {
                if (item.name === val) {
                    text = item.title;
                    pid = item.id
                }
            });
            list2[index].title = text
            list2[index].productId = pid
            return text;
        },
    },
}
</script>
